import { render, staticRenderFns } from "./EndCard.vue?vue&type=template&id=b5bc88e0&scoped=true"
import script from "./EndCard.vue?vue&type=script&lang=js"
export * from "./EndCard.vue?vue&type=script&lang=js"
import style0 from "./EndCard.vue?vue&type=style&index=0&id=b5bc88e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bc88e0",
  null
  
)

export default component.exports